import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("sf_cart")) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("sf_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (item) => {
    setItems((prev) => [...prev.filter((i) => i.product_id !== item.product_id), item]);
  };
  const removeItem = (productId) => setItems((prev) => prev.filter((i) => i.product_id !== productId));
  const clear = () => setItems([]);
  const count = items.length;

  const value = useMemo(() => ({ items, addItem, removeItem, clear, count }), [items]);
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  return useContext(CartContext);
}
